import GLightbox from "glightbox";

export default class LightBox {
  constructor() {
    const lightbox = GLightbox({
      touchNavigation: true,
      loop: true,
      autoplayVideos: true,
      width: '100vw',
      height: '100vh',
      zoomable: true,
    })
  }
}
